import React, { useRef, useState } from "react";
import Chip from "@/components/Chip";
import routes from "@/helpers/router";
import { getCookie } from "@/helpers/cookies";
import useScrollDirection from "@/redux/hooks/useScrollDirection";
import { HOME_PAGE_TITLE, ONBOARDED_HOME_PAGE_TITLE } from "@/helpers/constants";
import MenuWeb from "@/components/Menu/MenuWeb";
import { DeviceInfo } from "@/interface/deviceInfo";
import { getSortedLinks } from "@/components/Header/helpers";
import { DeregisterRefType, RefsObjectType, RegisterRefType } from "@/components/PageHome/interfaces";
import styles from "./NavBar.module.scss";

interface NavBarProps {
  navBarData: any;
  userOnBoarded: boolean;
  userAgent: DeviceInfo;
  pathname: string;
}

const NavBar: React.FC<NavBarProps> = ({ navBarData, userOnBoarded, userAgent, pathname }) => {
  const [activeSlug, setActiveSlug] = useState<string>("");
  // const pathname: string = usePathname();
  const pageLinks = getSortedLinks(navBarData?.navBarList, pathname, userAgent);

  const scrollDirection = useScrollDirection();

  const elementRefs = useRef<RefsObjectType>({});

  const registerRef: RegisterRefType = (key, element) => {
    elementRefs.current[key] = element;
  };

  const isUserOnBoarded: () => boolean = () => {
    // When user completes onboarding userOnBoarded would be false, therefore using getCookie
    return userOnBoarded || !!getCookie("segmentInfo");
  };

  let timeout = undefined;

  const handleHover: (type: "enter" | "leave", slug: string) => void = (type, slug) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      switch (type) {
        case "enter":
          setActiveSlug(slug);
          break;
        case "leave":
        default:
          setActiveSlug("");
      }
    }, 100);
  };

  return (
    <div className={`${styles.naviRoot} ${scrollDirection === "down" && userAgent?.isMobile ? styles.topfix : ""}`}>
      <div className={`container ${styles.naviContainer}`}>
        <div className={`${styles.navigationWrapper} `}>
          <div className={styles.chips}>
            <Chip
              href={routes.home}
              className={`${styles.chip} ${pathname === routes.home ? styles.active : ""}`}
              name={isUserOnBoarded() ? ONBOARDED_HOME_PAGE_TITLE : HOME_PAGE_TITLE}
            />
            {pageLinks?.map((link: any) => {
              const { Name, slug, urlWithBasePath, isActive } = link;

              return (
                <Chip
                  registerRef={registerRef}
                  onHover={(type) => {
                    handleHover(type, slug);
                  }}
                  slug={slug}
                  href={urlWithBasePath}
                  className={`${styles.chip} ${isActive ? styles.active : ""}`}
                  key={slug}
                  name={Name}
                />
              );
            })}
          </div>
        </div>
        {userAgent?.isDesktop &&
          pageLinks?.map(({ slug }: any) => {
            return <MenuWeb key={slug} menuSlug={slug} navRef={elementRefs?.current} activeSlug={activeSlug} />;
          })}
      </div>
    </div>
  );
};

export default NavBar;
